import React from 'react';
import { redirectToStore } from '@/utils/appStoreRedirect';

/**
 * Rendered for /app/* only when the OS did NOT intercept the universal/app
 * link (app not installed, or desktop). Sends the visitor to the right store.
 */
export default function AppRedirect(): React.JSX.Element | null {
  // Guard so the redirect fires once per mount even under StrictMode's
  // double-invoked effects (dev), avoiding a double navigation.
  const fired = React.useRef(false);
  React.useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    redirectToStore();
  }, []);
  return null;
}
